export const APP_BUILD_INFO = {
  version: "1.0.18",
  buildNumber: "127",
  commitSha: "0b4cec08b7b4",
  channel: "staging" as string
} as const;
